/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { Link, useTranslations } from "@i18n/next";
import { Button, Container, spacing, Stack, Text } from "@packages/ui";

const stackStyles: Interpolation = {
  alignItems: "center",
  marginTop: spacing.l,
  padding: spacing.m,
  textAlign: "center",
};

export default function NotFound() {
  const t = useTranslations();
  return (
    <Container size="xs" maxWidth>
      <Stack gap={spacing.m} css={stackStyles}>
        <Text as="h1" type="headline" size="l">
          {t("web_404_title")}
        </Text>
        {t("web_404_explanation")}
        <Button asChild size="m">
          <Link href="/">{t("web_404_go_to_home")}</Link>
        </Button>
      </Stack>
    </Container>
  );
}
